import { ReactNode } from 'react';

import { Endpoints } from '@/api';
import {
  FilterCheckboxItem,
  FilterItemNoResults,
  FiltersList,
  FiltersSubMenu,
} from '@/design_system/Filters/FiltersDrawer/FiltersDrawer';
import IconCloth from '@/icons/Cloth.svg';
import { type Brand, computeBrandName, useBrands } from '@/models/brand';

export const MobileBrandFilter = ({
  filterId,
  selectedBrands,
  setSelectedBrands,
  brandsQuery,
  label,
  icon = <IconCloth />,
}: {
  filterId: string;
  selectedBrands: Brand[];
  setSelectedBrands: (brands: Brand[]) => void;
  brandsQuery: Endpoints['GET /brands']['query'];
  label: string;
  icon?: ReactNode;
}) => {
  const { data } = useBrands(brandsQuery);

  const brandsOptions = data?.brands ?? [];

  const options =
    brandsOptions.length > 0 ? (
      brandsOptions.map((brand: Brand) => (
        <FilterCheckboxItem
          key={brand.id}
          id={brand.id}
          label={computeBrandName(brand, brandsOptions)}
        />
      ))
    ) : (
      <FilterItemNoResults />
    );

  const toggleBrand = (brand: Brand) => {
    if (selectedBrands.some((brd) => brd.id === brand.id)) {
      setSelectedBrands(selectedBrands.filter((brd) => brd.id !== brand.id));
    } else {
      setSelectedBrands([...selectedBrands, brand]);
    }
  };

  if (!data?.brands.length) {
    return null;
  }

  return (
    <FiltersSubMenu id={filterId} icon={icon} label={label} count={selectedBrands.length}>
      <FiltersList
        ariaLabel={label}
        values={selectedBrands.map((brd) => brd.id)}
        onChange={(newBrandId) => {
          const newBrand = brandsOptions.find((brandOption) => brandOption.id === newBrandId);

          if (newBrand) {
            toggleBrand(newBrand);
          }
        }}
      >
        {options}
      </FiltersList>
    </FiltersSubMenu>
  );
};
